/** Brand lockup aligned with meisterpfad-website / field app (Brandbook v1.2). */

import logoWordmark from '../assets/logo-watermark.png';
import logoWordmarkDark from '../assets/logo-wordmark-dark.png';

const TOP_FILL = '#2563eb';
const SIDE_DARK = '#111827';
const SIDE_LIGHT = '#FFFFFF';

/** Meisterpfad mark — SVG sides flip white on dark backgrounds (matches field app). */
export function BrandIcon({
  size = 32,
  className = '',
  onDark = false,
  onCobalt = false,
}: {
  size?: number;
  className?: string;
  onDark?: boolean;
  onCobalt?: boolean;
}) {
  const height = Math.round((size * 110) / 100);
  const sideColor = onDark || onCobalt ? SIDE_LIGHT : SIDE_DARK;

  return (
    <svg
      width={size}
      height={height}
      viewBox="0 0 100 110"
      className={`block shrink-0 ${className}`}
      aria-hidden
    >
      <polygon points="2,30 50,55 50,107 2,82" fill={sideColor} />
      <polygon points="98,30 50,55 50,107 98,82" fill={sideColor} />
      <polygon points="50,3 98,30 50,55 2,30" fill={TOP_FILL} />
    </svg>
  );
}

export function BrandLogo({
  className = '',
  onDark = false,
}: {
  className?: string;
  onDark?: boolean;
}) {
  const wordmark = onDark ? logoWordmark : logoWordmarkDark;

  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <BrandIcon size={24} onDark={onDark} />
      <img
        src={wordmark}
        alt="MeisterPfad"
        className="h-3.5 w-auto shrink-0 object-contain"
      />
    </span>
  );
}
